import {computed, observable, toJS} from "mobx";
import ReportBoxesService from "../services/ReportBoxes";
import UserService from "../services/User";
import UsersService from "../services/Users"
import * as _ from "lodash"
import {isContained, splitTags} from "../helpers/array";

export default class TeachersStore {
    @observable reportBoxes = [];
    @observable selectedTags=[];//筛选选中的tag；
    @observable allBoxTags=[];//存入数据库中的所有作业箱的tag（未处理）
    @observable allowedBoxes=[];//允许加入的作业箱
    @observable isModalVisible=false;
    @observable teachers=[];
    @observable selectedTeacher;

    constructor() {
        this.getReportBoxes();
        this.getTeachers();
    }
    getReportBoxes=async()=>{
        const user=UserService.getCurrentUserName();
        this.reportBoxes=await ReportBoxesService.getStudentReportBoxes(user);
        // const boxId=reportBoxes.map(b=>b._id);
        // const reports=await ReportsService.getReportsByBoxId(boxId,user);
        // const reportDict=_.groupBy(reports,"boxId");
        // this.reportBoxes=reportBoxes.map(box=>{
        //     const reports=reportDict[box._id]||[];
        //     const submittedReports=reports.filter(report=>report.status&&report.status.startsWith("已提交"));
        //     return {...box,count:reports.length||0,submittedCount:submittedReports.length||0}
        // });
        this.allBoxTags=this.reportBoxes.map(b=>b.tags);
    };
    getAllowedReportBoxes=async()=>{
        const allowedBoxes=await ReportBoxesService.getAllowedReportBoxes();
        const owners=allowedBoxes.map(b=>b.owner) ;
        const teachers=await UsersService.getUsersByUsernames(owners);
        const teacherDict=_.keyBy(teachers,'username');
        this.allowedBoxes=allowedBoxes.map(box=>{
            const owner=teacherDict[box.owner]||{};
            return {...box,teacher:owner.showName}
        })
    };
    getTeachers=async()=>{
        this.teachers=await UsersService.getUsers(true)
    };

    //处理过的数据库中的报告箱tags
    @computed get boxTags(){
        const tags=toJS(this.allBoxTags);
        //去掉一层数据
        const _tags= _.flatten(tags);
        // 去掉数组中的空值；
        const __tags = _.compact(_tags);
        // 返回没有重复的标签数组
        return _.uniq(__tags)
    }
    selectTag=(tag, checked)=>{
        this.selectedTags = checked ? [...this.selectedTags, tag] : this.selectedTags.filter(t => t !== tag);
    };


    // @computed get selectedBoxes(){
    //     return this.reportBoxes.filter(box=>{
    //         const qTags = toJS(box.tags)||[];
    //         const qTagItems = splitTags(qTags);
    //         return isContained(qTagItems, toJS(this.selectedTags));
    //     });
    // }


    @computed get groupedSelectedBoxes() {
        const boxes = this.reportBoxes.filter(box => {
            // 看是否有选择标签，没有选择标签就全部显示
            if (this.selectedTags?.length) {
                let exist = false;
                // 查找作业箱中包含这个标签的作业箱 只要作业箱中包含其中一个标签就可以
                this.selectedTags.forEach(tag => {
                    if (box.tags.includes(tag)) exist = true;
                });
                return exist ? box : null;
            } else {
                return box;
            }
        });
    
        // 按创建时间由远到近排序
        const sortedBoxes = _.orderBy(boxes, ['createdAt'], ['desc']);
    
        const unArchivedBoxes = _.remove(sortedBoxes, function (box) {
            return !(box.isArchived) || box.isArchived === false;
        });
    
        return { 'unArchived': unArchivedBoxes, 'archived': sortedBoxes };
    }


    showModal=()=>{
        this.isModalVisible=true;
        this.getAllowedReportBoxes();
    };
    //加入或者退出作业箱
    joinOrQuitReportBox=async(isJoin,box)=>{
        if(isJoin){
            await ReportBoxesService.quitReportBox(box._id)
        }else {
            await ReportBoxesService.joinReportBox(box._id)
        }
        this.getAllowedReportBoxes();
        this.getReportBoxes();
    };

    @computed get allowJoinBoxes(){
        if(this.selectedTeacher){
            return this.allowedBoxes.filter(box=>box.owner===this.selectedTeacher)
        }else return this.allowedBoxes
    }

    selectTeacher=(teacher)=>{
        this.selectedTeacher=teacher
    }

}